import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Datetime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  LicenseRef: { input: any; output: any; }
  PropertyRef: { input: any; output: any; }
  Timestamp: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type AddressLines = {
  __typename?: 'AddressLines';
  city?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  line_1?: Maybe<Scalars['String']['output']>;
  line_2?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type AddressPieces = {
  __typename?: 'AddressPieces';
  city?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  no?: Maybe<Scalars['String']['output']>;
  prefix?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street_name?: Maybe<Scalars['String']['output']>;
  street_type?: Maybe<Scalars['String']['output']>;
  suffix?: Maybe<Scalars['String']['output']>;
  unit_number?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type Agreement = {
  __typename?: 'Agreement';
  key?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type AirbnbRemit = {
  __typename?: 'AirbnbRemit';
  enable?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type AppUser = {
  __typename?: 'AppUser';
  regions?: Maybe<Array<RegionConfig>>;
};


export type AppUserRegionsArgs = {
  configType?: InputMaybe<RegionConfigType>;
};

export type ApplicationUpdate = {
  __typename?: 'ApplicationUpdate';
  application: License;
  effectiveEndDate: Scalars['Datetime']['output'];
  effectiveStartDate: Scalars['Datetime']['output'];
  isCurrent: Scalars['Boolean']['output'];
  payment?: Maybe<PaymentPeriod>;
};

export type AttachedFile = {
  __typename?: 'AttachedFile';
  fileName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  link: Scalars['String']['output'];
};

export type Calendar = {
  __typename?: 'Calendar';
  address?: Maybe<Scalars['String']['output']>;
  apn?: Maybe<Scalars['String']['output']>;
  booked?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  propertyId: Scalars['String']['output'];
};

export type CalendarFilters = {
  booked?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CalendarResult = {
  __typename?: 'CalendarResult';
  edges?: Maybe<Array<Maybe<Calendar>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type CollectionAgreement = {
  __typename?: 'CollectionAgreement';
  enable?: Maybe<Scalars['Boolean']['output']>;
  with?: Maybe<Array<Maybe<Agreement>>>;
};

export enum CommonLicenseStatus {
  Active = 'Active',
  Created = 'created',
  Current = 'current',
  Deleted = 'deleted',
  Denied = 'denied',
  Deregistered = 'deregistered',
  Expired = 'expired',
  Revoked = 'revoked',
  Submitted = 'submitted'
}

export type Contact = {
  __typename?: 'Contact';
  alternative_phone: Scalars['String']['output'];
  email: Scalars['String']['output'];
  full_name: Scalars['String']['output'];
  kind: ContactType;
  phone: Scalars['String']['output'];
};

export enum ContactField {
  AlternativePhone = 'ALTERNATIVE_PHONE',
  Email = 'EMAIL',
  FullName = 'FULL_NAME',
  Phone = 'PHONE',
  Unspecified = 'UNSPECIFIED'
}

export type ContactFieldSource = {
  __typename?: 'ContactFieldSource';
  contact: ContactType;
  field: ContactField;
};

export enum ContactType {
  LocalContact = 'LOCAL_CONTACT',
  Owner = 'OWNER',
  PropertyManager = 'PROPERTY_MANAGER',
  Registrant = 'REGISTRANT',
  RentalAgent = 'RENTAL_AGENT',
  Unspecified = 'UNSPECIFIED'
}

export type ContactsFilterInput = {
  types: Array<ContactType>;
};

export type CoordPair = {
  __typename?: 'CoordPair';
  apn: Scalars['String']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  type: PropertyScapePropertyTypeFlags;
};

export enum DiscrepancyStatus {
  HasUninvestigatedDiscrepancy = 'HAS_UNINVESTIGATED_DISCREPANCY'
}

export type DisplayInfo = {
  __typename?: 'DisplayInfo';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type DisplayedField = {
  __typename?: 'DisplayedField';
  contact?: Maybe<ContactFieldSource>;
  label: Scalars['String']['output'];
  license?: Maybe<LicenseFieldSource>;
  taxonomy?: Maybe<TaxonomySource>;
  whenEmpty: EmptyFieldDisplayStrategy;
};

export enum EmptyFieldDisplayStrategy {
  Hide = 'HIDE',
  Unspecified = 'UNSPECIFIED'
}

export type EnumType = {
  __typename?: 'EnumType';
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ErrorMessage = {
  __typename?: 'ErrorMessage';
  errorMessage: Scalars['String']['output'];
};

export type FilteredInspections = {
  __typename?: 'FilteredInspections';
  allInspections?: Maybe<Array<Maybe<Inspection>>>;
  incompleteInspections?: Maybe<Array<Maybe<Inspection>>>;
  recentlyCompletedInspections?: Maybe<Array<Maybe<Inspection>>>;
  upcomingInspections?: Maybe<Array<Maybe<Inspection>>>;
};

export type GeoCluster = {
  __typename?: 'GeoCluster';
  cluster_size: Scalars['Int']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type Inspection = {
  __typename?: 'Inspection';
  apn: Scalars['String']['output'];
  attachments?: Maybe<Array<Maybe<AttachedFile>>>;
  deckardid?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  inspectionResult?: Maybe<Scalars['String']['output']>;
  inspectionTime: Scalars['Datetime']['output'];
  inspectionType?: Maybe<Scalars['String']['output']>;
  inspector?: Maybe<Scalars['String']['output']>;
  issueSeverity?: Maybe<InspectionIssueSeverity>;
  misc?: Maybe<Scalars['JSON']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  propertyAddress?: Maybe<Scalars['String']['output']>;
  propertyType?: Maybe<Scalars['String']['output']>;
  submissionTime: Scalars['Datetime']['output'];
};

export type InspectionConfig = {
  __typename?: 'InspectionConfig';
  defaultReInspectionPeriod: Scalars['String']['output'];
  inspectionResult?: Maybe<InspectionResultConfig>;
  inspectionRole: Array<Maybe<EnumType>>;
  inspectionTypes: Array<Maybe<EnumType>>;
  mode?: Maybe<Scalars['String']['output']>;
  onSiteInspectionSections: Array<Maybe<InspectionQuestionSection>>;
  propertyTypes: Array<Maybe<EnumType>>;
  questionLabels?: Maybe<QuestionLabels>;
  read?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  rw?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type InspectionHeaderBodyHtml = {
  __typename?: 'InspectionHeaderBodyHtml';
  body_html: Scalars['String']['output'];
  header_html: Scalars['String']['output'];
};

export type InspectionInput = {
  apn: Scalars['String']['input'];
  contactPersonEmail?: InputMaybe<Scalars['String']['input']>;
  contactPersonName?: InputMaybe<Scalars['String']['input']>;
  contactPersonPhone?: InputMaybe<Scalars['String']['input']>;
  contactPersonRole?: InputMaybe<Scalars['String']['input']>;
  inspectionResult?: InputMaybe<Scalars['String']['input']>;
  inspectionTime: Scalars['Datetime']['input'];
  inspectionType?: InputMaybe<Scalars['String']['input']>;
  inspector?: InputMaybe<Scalars['String']['input']>;
  inspectorEmail?: InputMaybe<Scalars['String']['input']>;
  inspectorPhone?: InputMaybe<Scalars['String']['input']>;
  inspectorType?: InputMaybe<Scalars['String']['input']>;
  issueSeverity?: InputMaybe<InspectionIssueSeverity>;
  notes?: InputMaybe<Scalars['String']['input']>;
  propertyType?: InputMaybe<Scalars['String']['input']>;
  reinspectionTime?: InputMaybe<Scalars['Datetime']['input']>;
  unitNumber?: InputMaybe<Scalars['String']['input']>;
};

export enum InspectionIssueSeverity {
  Major = 'major',
  Minor = 'minor',
  None = 'none'
}

export type InspectionNote = {
  __typename?: 'InspectionNote';
  attachments: Scalars['String']['output'];
  mode: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type InspectionOrError = ErrorMessage | Inspection;

export type InspectionOwnerDetails = {
  __typename?: 'InspectionOwnerDetails';
  email: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  primaryPhone?: Maybe<Scalars['String']['output']>;
};

export type InspectionParcelDataSection = {
  __typename?: 'InspectionParcelDataSection';
  apn: Scalars['String']['output'];
  bedrooms: Scalars['String']['output'];
  city: Scalars['String']['output'];
  county: Scalars['String']['output'];
  ownerAddress: Scalars['String']['output'];
  ownerName: Scalars['String']['output'];
  propertyAddress: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

export type InspectionQuestionSection = {
  __typename?: 'InspectionQuestionSection';
  notes?: Maybe<InspectionNote>;
  optional: Scalars['Boolean']['output'];
  questions: Scalars['JSON']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export enum InspectionResult {
  Fail = 'fail',
  InProgress = 'in_progress',
  Success = 'success'
}

export type InspectionResultConfig = {
  __typename?: 'InspectionResultConfig';
  fail: Array<Maybe<InspectionHeaderBodyHtml>>;
  success: Array<Maybe<InspectionHeaderBodyHtml>>;
};

export type InspectionSummary = {
  __typename?: 'InspectionSummary';
  basicInspectionFields: Inspection;
  ownerDetails?: Maybe<InspectionOwnerDetails>;
};

export enum InterestStatus {
  HasInterest = 'HAS_INTEREST',
  NoInterest = 'NO_INTEREST'
}

export enum InvestigationStatus {
  Investigated = 'INVESTIGATED',
  NotInvestigated = 'NOT_INVESTIGATED'
}

export type JurisdictionSpecificTaxes = {
  __typename?: 'JurisdictionSpecificTaxes';
  amountInCents: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type Legend = {
  __typename?: 'Legend';
  colorHex: Scalars['String']['output'];
  count?: Maybe<Scalars['Int']['output']>;
  formattedText: Scalars['String']['output'];
  propertyType?: Maybe<PropertyType>;
  tooltip?: Maybe<Scalars['String']['output']>;
};

export type License = {
  __typename?: 'License';
  apn: Scalars['String']['output'];
  applicationDate?: Maybe<Scalars['String']['output']>;
  applicationNumber?: Maybe<Scalars['String']['output']>;
  balance: Scalars['Float']['output'];
  expirationDate?: Maybe<Scalars['String']['output']>;
  history: Array<LicenseSnapshot>;
  isActive: Scalars['Boolean']['output'];
  issueDate?: Maybe<Scalars['String']['output']>;
  licenseDeckardid: Scalars['String']['output'];
  licenseId?: Maybe<Scalars['String']['output']>;
  licenseMisc?: Maybe<Scalars['JSON']['output']>;
  licenseNumber?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Array<Maybe<Note>>>;
  parcel?: Maybe<Parcel>;
  payments?: Maybe<Array<Maybe<Payment>>>;
  people?: Maybe<Scalars['JSON']['output']>;
  site_address?: Maybe<Scalars['String']['output']>;
  standardPeople: LicenseStandardPeople;
  status: Scalars['String']['output'];
  transactions: Array<PaymentTransaction>;
  unitNumber?: Maybe<Scalars['String']['output']>;
};

export type LicenseContact = {
  __typename?: 'LicenseContact';
  address?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  licenseNumber: Scalars['String']['output'];
  name: Scalars['String']['output'];
  personType: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
};

export type LicenseDataForInspection = {
  __typename?: 'LicenseDataForInspection';
  bedrooms?: Maybe<Scalars['String']['output']>;
};

export type LicenseEdge = {
  __typename?: 'LicenseEdge';
  node?: Maybe<License>;
};

export enum LicenseField {
  Apn = 'APN',
  ExpirationDate = 'EXPIRATION_DATE',
  LicenseNumber = 'LICENSE_NUMBER',
  NumberOfBedrooms = 'NUMBER_OF_BEDROOMS',
  Occupancy = 'OCCUPANCY',
  Status = 'STATUS',
  Unit = 'UNIT',
  Unspecified = 'UNSPECIFIED'
}

export type LicenseFieldSource = {
  __typename?: 'LicenseFieldSource';
  field?: Maybe<LicenseField>;
};

export type LicenseResults = {
  __typename?: 'LicenseResults';
  contToken?: Maybe<Scalars['String']['output']>;
  licenses?: Maybe<Array<Maybe<License>>>;
};

export type LicenseSnapshot = {
  __typename?: 'LicenseSnapshot';
  date: Scalars['Datetime']['output'];
  snapshot: License;
};

export type LicenseStandardPeople = {
  __typename?: 'LicenseStandardPeople';
  owner?: Maybe<Person>;
  registrant?: Maybe<Person>;
};

export enum LicenseStatus {
  Unknown = 'UNKNOWN',
  Valid = 'VALID'
}

export type LicenseTotStatusResult = {
  __typename?: 'LicenseTOTStatusResult';
  contToken?: Maybe<Scalars['Int']['output']>;
  licenses: Array<License>;
};

export enum LicenseType {
  Permit = 'PERMIT',
  Str = 'STR'
}

export type Licenses = {
  __typename?: 'Licenses';
  licenses?: Maybe<Array<Maybe<License>>>;
};

export type Link = {
  __typename?: 'Link';
  displayValue: Scalars['String']['output'];
  label: Scalars['String']['output'];
  tooltip?: Maybe<Scalars['String']['output']>;
  type: LinkType;
  value: Scalars['String']['output'];
};

export enum LinkType {
  Email = 'EMAIL',
  Phone = 'PHONE',
  Url = 'URL'
}

export type Listing = {
  __typename?: 'Listing';
  active: Scalars['Boolean']['output'];
  bathrooms?: Maybe<Scalars['Int']['output']>;
  bedrooms?: Maybe<Scalars['Int']['output']>;
  creationDate?: Maybe<Scalars['String']['output']>;
  listingId: Scalars['String']['output'];
  live: Scalars['Boolean']['output'];
  occupancy?: Maybe<Scalars['Int']['output']>;
  provider: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  verified: Scalars['Boolean']['output'];
};

export type Location = {
  __typename?: 'Location';
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addInspection?: Maybe<Inspection>;
  addNote?: Maybe<Note>;
  clearSingleSignOnAttributeMapping: SingleSignOn;
  createAdminUpdateFlowToken: Scalars['String']['output'];
  deleteInspection: Scalars['Boolean']['output'];
  /** Marks the discrepancy for a tax item as investigated. */
  markDiscrepancyAsInvestigated: Scalars['Boolean']['output'];
  /**
   * Report the result of an inspection, saving both the result and detailed breakdown if provided.
   *
   * Args
   * - regionId:     A unique identifier representing a specific region where the inspection took place.
   * - inspection:   Input object of type ReportInspectionResultInput with details about the inspection result.
   *
   * Returns:        A union type that can resolve to either an 'Inspection' or an 'ErrorMessage'.
   */
  reportInspectionResult?: Maybe<InspectionOrError>;
  rollbackLicenseStatus?: Maybe<License>;
  sendInspectionNotice?: Maybe<Scalars['Boolean']['output']>;
  sendInspectionResult: Scalars['Boolean']['output'];
  setSingleSignOnAttributeMapping: SingleSignOn;
  updateLicenseStatus?: Maybe<License>;
  updateSingleSignOn: SingleSignOn;
};


export type MutationAddInspectionArgs = {
  attachments?: InputMaybe<Scalars['Upload']['input']>;
  emailRecipients?: InputMaybe<Array<Scalars['String']['input']>>;
  inspection: InspectionInput;
  regionId: Scalars['String']['input'];
};


export type MutationAddNoteArgs = {
  note_info: NoteInput;
  regionId: Scalars['String']['input'];
};


export type MutationClearSingleSignOnAttributeMappingArgs = {
  regionId: Scalars['String']['input'];
  toUserPoolAttribute: SsoUserPoolAttribute;
};


export type MutationCreateAdminUpdateFlowTokenArgs = {
  applicationNumber: Scalars['String']['input'];
  regionId: Scalars['String']['input'];
};


export type MutationDeleteInspectionArgs = {
  inspectionId: Scalars['String']['input'];
  regionId: Scalars['String']['input'];
};


export type MutationMarkDiscrepancyAsInvestigatedArgs = {
  regionId: Scalars['ID']['input'];
  taxItemId: Scalars['ID']['input'];
};


export type MutationReportInspectionResultArgs = {
  inspection: ReportInspectionResultInput;
  regionId: Scalars['String']['input'];
};


export type MutationRollbackLicenseStatusArgs = {
  licenseId: Scalars['String']['input'];
  regionId: Scalars['String']['input'];
};


export type MutationSendInspectionNoticeArgs = {
  emailRecipients: Array<InputMaybe<Scalars['String']['input']>>;
  inspectionId: Scalars['String']['input'];
  regionId: Scalars['String']['input'];
};


export type MutationSendInspectionResultArgs = {
  correctionCompletionDate?: InputMaybe<Scalars['String']['input']>;
  inspectionId: Scalars['String']['input'];
  regionId: Scalars['String']['input'];
};


export type MutationSetSingleSignOnAttributeMappingArgs = {
  fromSamlAttribute: Scalars['String']['input'];
  regionId: Scalars['String']['input'];
  toUserPoolAttribute: SsoUserPoolAttribute;
};


export type MutationUpdateLicenseStatusArgs = {
  licenseId: Scalars['String']['input'];
  newStatus: CommonLicenseStatus;
  regionId: Scalars['String']['input'];
};


export type MutationUpdateSingleSignOnArgs = {
  configuration: SingleSignOnInput;
  regionId: Scalars['String']['input'];
};

export type Note = {
  __typename?: 'Note';
  attachments: Array<AttachedFile>;
  contents?: Maybe<Scalars['String']['output']>;
  createdTimestamp?: Maybe<Scalars['Datetime']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  misc?: Maybe<Scalars['JSON']['output']>;
  moved?: Maybe<Scalars['Boolean']['output']>;
  noteId?: Maybe<Scalars['Int']['output']>;
  updatedTimestamp?: Maybe<Scalars['Datetime']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type NoteInput = {
  attachments?: InputMaybe<Scalars['Upload']['input']>;
  deckardId: Scalars['String']['input'];
  message: Scalars['String']['input'];
};

export type Otr = {
  __typename?: 'OTR';
  endDate?: Maybe<Scalars['Datetime']['output']>;
  periods: Array<OtrPeriod>;
  registrationType: RegistrationType;
  startDate: Scalars['Datetime']['output'];
};


export type OtrPeriodsArgs = {
  endDate?: InputMaybe<Scalars['Datetime']['input']>;
};

export type OtrPeriod = {
  __typename?: 'OTRPeriod';
  applicationUpdates: Array<ApplicationUpdate>;
  endDate: Scalars['Datetime']['output'];
  paymentPeriod?: Maybe<PaymentPeriod>;
  startDate: Scalars['Datetime']['output'];
};

export type OutreachSchedule = {
  __typename?: 'OutreachSchedule';
  /**
   * Next scheduled run date of outreach letters.
   * Fetched from letter generation event lambda, it's in yyyy-mm-dd format.
   * Optional, since a run may not always be scheduled.
   */
  nextRunTime?: Maybe<Scalars['String']['output']>;
  /** A list of violation types configured in customer-config */
  violationOutreachList: Array<ViolationOutreach>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage?: Maybe<Scalars['String']['output']>;
};

export type PaginatedInspections = {
  __typename?: 'PaginatedInspections';
  inspections?: Maybe<Array<Maybe<Inspection>>>;
  paginationInfo: PaginationInfo;
};

export type PaginationInfo = {
  __typename?: 'PaginationInfo';
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type Parcel = {
  __typename?: 'Parcel';
  apn?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  streetAddress?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type ParcelForeclosure = {
  __typename?: 'ParcelForeclosure';
  latestTransaction: ParcelForeclosureTransactions;
  parcelForeclosures?: Maybe<Array<Maybe<ParcelForeclosureTransactions>>>;
  propertyInfo?: Maybe<PropertyInfo>;
};

export enum ParcelForeclosureTransactionType {
  /** Lis Pendens */
  Lis = 'LIS',
  Nod = 'NOD',
  Nos = 'NOS',
  Nts = 'NTS'
}

export type ParcelForeclosureTransactions = {
  __typename?: 'ParcelForeclosureTransactions';
  auctionDate?: Maybe<Scalars['String']['output']>;
  createDate?: Maybe<Scalars['String']['output']>;
  defaultAmount?: Maybe<Scalars['Float']['output']>;
  detectionDate?: Maybe<Scalars['String']['output']>;
  foreclosureRecordingDate?: Maybe<Scalars['String']['output']>;
  loanBalance?: Maybe<Scalars['Float']['output']>;
  mortgageeAddress?: Maybe<Scalars['String']['output']>;
  mortgageeName?: Maybe<Scalars['String']['output']>;
  mortgageePhone?: Maybe<Scalars['String']['output']>;
  ownerName?: Maybe<Scalars['String']['output']>;
  payment?: Maybe<Scalars['Float']['output']>;
  penaltyInterest?: Maybe<Scalars['Float']['output']>;
  recordLastUpdated?: Maybe<Scalars['String']['output']>;
  recordType?: Maybe<ParcelForeclosureTransactionType>;
  transactionId?: Maybe<Scalars['String']['output']>;
  trusteeAddress?: Maybe<Scalars['String']['output']>;
  trusteeName?: Maybe<Scalars['String']['output']>;
  trusteePhone?: Maybe<Scalars['String']['output']>;
};

export type Payee = {
  __typename?: 'Payee';
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type Payment = {
  __typename?: 'Payment';
  confirmationCode?: Maybe<Scalars['String']['output']>;
  paymentId: Scalars['Int']['output'];
  paymentPeriods?: Maybe<Array<Maybe<PaymentPeriod>>>;
  paymentStatus?: Maybe<Scalars['String']['output']>;
  paymentType?: Maybe<Scalars['String']['output']>;
  stripeIntentId?: Maybe<Scalars['String']['output']>;
  submission_date?: Maybe<Scalars['String']['output']>;
  submitter?: Maybe<Scalars['String']['output']>;
  submitterEmail?: Maybe<Scalars['String']['output']>;
  submitterPhone?: Maybe<Scalars['String']['output']>;
  submitterTitle?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type PaymentPeriod = {
  __typename?: 'PaymentPeriod';
  accruedInterest?: Maybe<Scalars['Float']['output']>;
  daysAvailable?: Maybe<Scalars['Int']['output']>;
  daysOccupied?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  formattedPeriod?: Maybe<Scalars['String']['output']>;
  latePenalties?: Maybe<Scalars['Float']['output']>;
  licenseFee?: Maybe<Scalars['Float']['output']>;
  payment?: Maybe<Payment>;
  paymentPeriodType?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  taxSummary?: Maybe<TaxSummary>;
  taxableReceipts?: Maybe<Scalars['Float']['output']>;
  tot?: Maybe<Scalars['Float']['output']>;
};

export enum PaymentStatus {
  Issue = 'ISSUE',
  Overdue = 'OVERDUE',
  Paid = 'PAID',
  Pending = 'PENDING',
  Unreported = 'UNREPORTED'
}

export type PaymentTransaction = {
  __typename?: 'PaymentTransaction';
  amount: Scalars['Float']['output'];
  date: Scalars['Datetime']['output'];
  description: Scalars['String']['output'];
  type: TransactionType;
};

export enum PenaltyStatus {
  HasPenalty = 'HAS_PENALTY',
  NoPenalty = 'NO_PENALTY'
}

export type Period = {
  endDate: Scalars['Datetime']['input'];
  /**
   * Represents a time period with start and end dates.
   *
   * Attributes:
   *     startDate (str): The start date of the period in ISO 8601 format (YYYY-MM-DD).
   *     endDate (str): The end date of the period in ISO 8601 format (YYYY-MM-DD).
   */
  startDate: Scalars['Datetime']['input'];
};

export type Person = {
  __typename?: 'Person';
  companyName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  mailingAddress?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type PropertiesMetricsResult = {
  __typename?: 'PropertiesMetricsResult';
  edges?: Maybe<Array<Maybe<PropertyMetrics>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type Property = {
  __typename?: 'Property';
  active?: Maybe<Scalars['Boolean']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  addressLines?: Maybe<AddressLines>;
  addressPieces?: Maybe<AddressPieces>;
  apn?: Maybe<Scalars['String']['output']>;
  claimingHoe?: Maybe<Scalars['String']['output']>;
  geo: Location;
  listings?: Maybe<Array<Maybe<Listing>>>;
  propertyId: Scalars['String']['output'];
  propertyParcelId?: Maybe<Scalars['String']['output']>;
  regionPropertiesId?: Maybe<Scalars['String']['output']>;
  rentalType?: Maybe<RentalType>;
};

export type PropertyContact = {
  __typename?: 'PropertyContact';
  company?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  mailingAddress?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
};

export type PropertyContacts = {
  __typename?: 'PropertyContacts';
  activeLicenseContacts?: Maybe<Array<Maybe<LicenseContact>>>;
  licenseData?: Maybe<LicenseDataForInspection>;
  parcelData: InspectionParcelDataSection;
};

export type PropertyContactsOrError = ErrorMessage | PropertyContacts;

export type PropertyCoordsResults = {
  __typename?: 'PropertyCoordsResults';
  contToken?: Maybe<Scalars['String']['output']>;
  properties: Array<CoordPair>;
};

export type PropertyInfo = {
  __typename?: 'PropertyInfo';
  apn: Scalars['String']['output'];
  city?: Maybe<Scalars['String']['output']>;
  deckardId: Scalars['String']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  state?: Maybe<Scalars['String']['output']>;
  streetAddress?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type PropertyMetrics = {
  __typename?: 'PropertyMetrics';
  estimated_stays_per_property?: Maybe<Scalars['Int']['output']>;
  license_displayed?: Maybe<Scalars['Int']['output']>;
  unique_properties_with_live_listings?: Maybe<Scalars['Int']['output']>;
  unique_properties_with_not_live_listings?: Maybe<Scalars['Int']['output']>;
  unverified_live_listings?: Maybe<Scalars['Int']['output']>;
  unverified_not_live_listings?: Maybe<Scalars['Int']['output']>;
  verified_properties?: Maybe<Scalars['Int']['output']>;
  yearMonth: Scalars['String']['output'];
};

export type PropertyResult = {
  __typename?: 'PropertyResult';
  edges?: Maybe<Array<Maybe<Property>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type PropertyResults = {
  __typename?: 'PropertyResults';
  contToken?: Maybe<Scalars['String']['output']>;
  mortgagees: Array<Scalars['String']['output']>;
  properties: Array<PropertyScapeProperty>;
  total: Scalars['Int']['output'];
};

export type PropertyScapePropertiesFilters = {
  address?: InputMaybe<Scalars['String']['input']>;
  applicationNumber?: InputMaybe<Scalars['String']['input']>;
  mortgageeName?: InputMaybe<Array<Scalars['String']['input']>>;
  registrationType?: InputMaybe<PropertyScapePropertiesTypeFilter>;
  status?: InputMaybe<PropertyScapePropertiesRegistrationStatusFilter>;
};

export enum PropertyScapePropertiesRegistrationStatusFilter {
  Deleted = 'DELETED',
  Expired = 'EXPIRED',
  Registered = 'REGISTERED',
  Unregistered = 'UNREGISTERED'
}

export enum PropertyScapePropertiesTypeFilter {
  Foreclosure = 'FORECLOSURE',
  Vacant = 'VACANT'
}

export type PropertyScapeProperty = {
  __typename?: 'PropertyScapeProperty';
  inspections: Array<Inspection>;
  licenses?: Maybe<Array<License>>;
  mortgagee?: Maybe<Person>;
  notes: Array<Note>;
  parcelForeclosures?: Maybe<Array<ParcelForeclosureTransactions>>;
  propertyInfo: PropertyInfo;
  propertyType: PropertyScapePropertyTypeFlags;
};

export type PropertyScapePropertyTypeFlags = {
  __typename?: 'PropertyScapePropertyTypeFlags';
  currentForeclosureLicense?: Maybe<License>;
  currentVacantLicense?: Maybe<License>;
  isForeclosed: Scalars['Boolean']['output'];
  isRegistered: Scalars['Boolean']['output'];
  isVacant: Scalars['Boolean']['output'];
};

export type PropertyScapeStatistics = {
  __typename?: 'PropertyScapeStatistics';
  mortgagees: Array<Scalars['String']['output']>;
  totalProperties: Scalars['Int']['output'];
};

export enum PropertyType {
  Exempt = 'EXEMPT',
  Licensed = 'LICENSED',
  LongTerm = 'LONG_TERM',
  Other = 'OTHER',
  ShortTerm = 'SHORT_TERM',
  Unknown = 'UNKNOWN',
  Unlicensed = 'UNLICENSED'
}

export type PublicPortalConfig = {
  __typename?: 'PublicPortalConfig';
  /** What data is used as source for markers on the map. */
  dataSource: PublicPortalDataSource;
  fields: Array<DisplayedField>;
  /** Whether the download button for the license list is displayed in the public portal or not. */
  isDownloadAvailable: Scalars['Boolean']['output'];
  /** License types displayed in the public portal. Empty list means no restrictions. */
  licenseTypes: Array<LicenseType>;
  listLegend?: Maybe<Scalars['String']['output']>;
  mapLegend?: Maybe<Scalars['String']['output']>;
  titleLine1?: Maybe<Scalars['String']['output']>;
  titleLine2?: Maybe<Scalars['String']['output']>;
};

export enum PublicPortalDataSource {
  LicensesV2 = 'LICENSES_V2',
  Unknown = 'UNKNOWN'
}

export type Query = {
  __typename?: 'Query';
  GetCalendars?: Maybe<CalendarResult>;
  GetLicenseByApn?: Maybe<Licenses>;
  GetLicenseByDeckardId?: Maybe<License>;
  GetLicenses?: Maybe<LicenseResults>;
  GetLicensesByGeoFence?: Maybe<LicenseResults>;
  GetParcelForeclosureByApn?: Maybe<ParcelForeclosure>;
  GetProperties?: Maybe<PropertyResult>;
  GetPropertiesMetrics?: Maybe<PropertiesMetricsResult>;
  GetPropertyScapeClusters: Array<GeoCluster>;
  GetPropertyScapeCount: PropertyScapeStatistics;
  GetPropertyScapeProperties: PropertyResults;
  GetPropertyScapePropertyByApn?: Maybe<PropertyScapeProperty>;
  GetPropertyScapePropertyClusters: Array<GeoCluster>;
  GetPropertyScapePropertyCoords: PropertyCoordsResults;
  GetRegionConfig?: Maybe<Region>;
  GetVFPRProperty?: Maybe<VfprProperty>;
  GetVFPRPropertyCoords: VpfrPropertyCoordsResults;
  GetVFPRPropertyList: VfprPropertyPage;
  GetVFPRPropertySummary: VfprPropertyPage;
  attachment?: Maybe<AttachedFile>;
  getCreateInspectionConfig?: Maybe<InspectionConfig>;
  getFilteredInspections?: Maybe<FilteredInspections>;
  getInspections?: Maybe<PaginatedInspections>;
  getLatestInspectionSummary?: Maybe<InspectionOrError>;
  getOutreachSchedule?: Maybe<OutreachSchedule>;
  getParcelDataAndPropertyContactsByApn?: Maybe<PropertyContactsOrError>;
  getSingleInspectionInfo?: Maybe<InspectionSummary>;
  hello: Scalars['JSON']['output'];
  licenseTOTStatus: LicenseTotStatusResult;
  listRegions?: Maybe<Array<Maybe<Region>>>;
  me?: Maybe<AppUser>;
  properties?: Maybe<Array<Maybe<Property>>>;
  region: Region;
};


export type QueryGetCalendarsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<CalendarFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate: Scalars['String']['input'];
  regionId: Scalars['String']['input'];
  toDate: Scalars['String']['input'];
};


export type QueryGetLicenseByApnArgs = {
  apn?: InputMaybe<Scalars['String']['input']>;
  regionId: Scalars['String']['input'];
};


export type QueryGetLicenseByDeckardIdArgs = {
  deckard_id?: InputMaybe<Scalars['String']['input']>;
  regionId: Scalars['String']['input'];
};


export type QueryGetLicensesArgs = {
  page_no?: InputMaybe<Scalars['Int']['input']>;
  regionId: Scalars['String']['input'];
};


export type QueryGetLicensesByGeoFenceArgs = {
  max_lat?: InputMaybe<Scalars['Float']['input']>;
  max_lng?: InputMaybe<Scalars['Float']['input']>;
  min_lat?: InputMaybe<Scalars['Float']['input']>;
  min_lng?: InputMaybe<Scalars['Float']['input']>;
  page_no?: InputMaybe<Scalars['Int']['input']>;
  regionId: Scalars['String']['input'];
};


export type QueryGetParcelForeclosureByApnArgs = {
  apn?: InputMaybe<Scalars['String']['input']>;
  regionId: Scalars['String']['input'];
};


export type QueryGetPropertiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  regionId: Scalars['String']['input'];
};


export type QueryGetPropertiesMetricsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['String']['input']>;
  regionId: Scalars['String']['input'];
  toDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPropertyScapeClustersArgs = {
  clusterDistance?: InputMaybe<Scalars['Float']['input']>;
  max_lat?: InputMaybe<Scalars['Float']['input']>;
  max_lng?: InputMaybe<Scalars['Float']['input']>;
  min_lat?: InputMaybe<Scalars['Float']['input']>;
  min_lng?: InputMaybe<Scalars['Float']['input']>;
  regionId: Scalars['String']['input'];
};


export type QueryGetPropertyScapeCountArgs = {
  max_lat?: InputMaybe<Scalars['Float']['input']>;
  max_lng?: InputMaybe<Scalars['Float']['input']>;
  min_lat?: InputMaybe<Scalars['Float']['input']>;
  min_lng?: InputMaybe<Scalars['Float']['input']>;
  regionId: Scalars['String']['input'];
};


export type QueryGetPropertyScapePropertiesArgs = {
  filters?: InputMaybe<PropertyScapePropertiesFilters>;
  max_lat?: InputMaybe<Scalars['Float']['input']>;
  max_lng?: InputMaybe<Scalars['Float']['input']>;
  min_lat?: InputMaybe<Scalars['Float']['input']>;
  min_lng?: InputMaybe<Scalars['Float']['input']>;
  page_no?: InputMaybe<Scalars['Int']['input']>;
  regionId: Scalars['String']['input'];
};


export type QueryGetPropertyScapePropertyByApnArgs = {
  apn?: InputMaybe<Scalars['String']['input']>;
  regionId: Scalars['String']['input'];
};


export type QueryGetPropertyScapePropertyClustersArgs = {
  clusterDistance?: InputMaybe<Scalars['Float']['input']>;
  filters?: InputMaybe<PropertyScapePropertiesFilters>;
  max_lat?: InputMaybe<Scalars['Float']['input']>;
  max_lng?: InputMaybe<Scalars['Float']['input']>;
  min_lat?: InputMaybe<Scalars['Float']['input']>;
  min_lng?: InputMaybe<Scalars['Float']['input']>;
  regionId: Scalars['String']['input'];
};


export type QueryGetPropertyScapePropertyCoordsArgs = {
  filters?: InputMaybe<PropertyScapePropertiesFilters>;
  max_lat?: InputMaybe<Scalars['Float']['input']>;
  max_lng?: InputMaybe<Scalars['Float']['input']>;
  min_lat?: InputMaybe<Scalars['Float']['input']>;
  min_lng?: InputMaybe<Scalars['Float']['input']>;
  page_no?: InputMaybe<Scalars['Int']['input']>;
  regionId: Scalars['String']['input'];
};


export type QueryGetRegionConfigArgs = {
  regionShortName: Scalars['String']['input'];
};


export type QueryGetVfprPropertyArgs = {
  apn: Scalars['String']['input'];
  regionId: Scalars['String']['input'];
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetVfprPropertyCoordsArgs = {
  filters?: InputMaybe<PropertyScapePropertiesFilters>;
  max_lat?: InputMaybe<Scalars['Float']['input']>;
  max_lng?: InputMaybe<Scalars['Float']['input']>;
  min_lat?: InputMaybe<Scalars['Float']['input']>;
  min_lng?: InputMaybe<Scalars['Float']['input']>;
  page_no?: InputMaybe<Scalars['Int']['input']>;
  regionId: Scalars['String']['input'];
};


export type QueryGetVfprPropertyListArgs = {
  apns?: InputMaybe<Array<Scalars['String']['input']>>;
  filters?: InputMaybe<PropertyScapePropertiesFilters>;
  page_no?: InputMaybe<Scalars['Int']['input']>;
  regionId: Scalars['String']['input'];
};


export type QueryGetVfprPropertySummaryArgs = {
  apns?: InputMaybe<Array<Scalars['String']['input']>>;
  filters?: InputMaybe<PropertyScapePropertiesFilters>;
  page_no?: InputMaybe<Scalars['Int']['input']>;
  regionId: Scalars['String']['input'];
};


export type QueryAttachmentArgs = {
  id: Scalars['String']['input'];
  regionId: Scalars['String']['input'];
};


export type QueryGetCreateInspectionConfigArgs = {
  regionId: Scalars['String']['input'];
};


export type QueryGetFilteredInspectionsArgs = {
  regionId: Scalars['String']['input'];
};


export type QueryGetInspectionsArgs = {
  apn: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  regionId: Scalars['String']['input'];
};


export type QueryGetLatestInspectionSummaryArgs = {
  apn: Scalars['String']['input'];
  regionId: Scalars['String']['input'];
};


export type QueryGetOutreachScheduleArgs = {
  regionId: Scalars['String']['input'];
};


export type QueryGetParcelDataAndPropertyContactsByApnArgs = {
  apn: Scalars['String']['input'];
  regionId: Scalars['String']['input'];
};


export type QueryGetSingleInspectionInfoArgs = {
  inspectionId: Scalars['String']['input'];
  regionId: Scalars['String']['input'];
};


export type QueryLicenseTotStatusArgs = {
  contToken?: InputMaybe<Scalars['Int']['input']>;
  regionId: Scalars['String']['input'];
  taxPeriodEnd: Scalars['Datetime']['input'];
  taxPeriodStart: Scalars['Datetime']['input'];
};


export type QueryListRegionsArgs = {
  configType?: InputMaybe<RegionConfigType>;
  regionName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRegionArgs = {
  regionId?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionLabels = {
  __typename?: 'QuestionLabels';
  fail: Scalars['String']['output'];
  pass: Scalars['String']['output'];
};

export type Region = {
  __typename?: 'Region';
  foreclosures: RegionForeclosureConnection;
  geoJson: Scalars['String']['output'];
  legalDisclaimer?: Maybe<RegionLegalDisclaimer>;
  legends?: Maybe<Array<Legend>>;
  licenses: RegionLicensesConnection;
  links?: Maybe<Array<Link>>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  publicPortalConfig?: Maybe<PublicPortalConfig>;
  regionName?: Maybe<Scalars['String']['output']>;
  regionShortName?: Maybe<Scalars['String']['output']>;
  registrations: RegionRegistrationsConnection;
  rentalscapeConfig?: Maybe<RentalscapeConfig>;
  reports: Array<Report>;
  singleSignOn?: Maybe<SingleSignOn>;
  statistics?: Maybe<Array<RegionStatistic>>;
  strLicenses: RegionStrLicensesConnection;
  support?: Maybe<SupportInfo>;
  taxItems: TaxItemConnection;
  taxReport: TaxReport;
  taxSummary: RegionTaxSummary;
  zonesConfig?: Maybe<RegionZonesConfig>;
};


export type RegionForeclosuresArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  order_by_desc?: InputMaybe<Scalars['String']['input']>;
  registered?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RegionLicensesArgs = {
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type RegionRegistrationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  include_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type RegionStrLicensesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<StrLicensesFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type RegionTaxItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter: TaxItemsFilterInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TaxItemOrder>>;
};


export type RegionTaxReportArgs = {
  filter: TaxItemsFilterInput;
  userTimezone?: InputMaybe<Scalars['String']['input']>;
};


export type RegionTaxSummaryArgs = {
  filter: TaxSummaryFilterInput;
};

export type RegionConfig = {
  __typename?: 'RegionConfig';
  configType?: Maybe<RegionConfigType>;
  region: Region;
  regionId: Scalars['String']['output'];
};

export enum RegionConfigType {
  Default = 'DEFAULT',
  Vfpr = 'VFPR'
}

export type RegionForeclosureConnection = {
  __typename?: 'RegionForeclosureConnection';
  count?: Maybe<Scalars['Int']['output']>;
  edges: Array<ParcelForeclosure>;
  pageInfo?: Maybe<PageInfo>;
};

export type RegionLegalDisclaimer = {
  __typename?: 'RegionLegalDisclaimer';
  confirmationText: Scalars['String']['output'];
  heading: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type RegionLicensesConnection = {
  __typename?: 'RegionLicensesConnection';
  count?: Maybe<Scalars['Int']['output']>;
  edges?: Maybe<Array<Maybe<LicenseEdge>>>;
};

export type RegionRegistrationsConnection = {
  __typename?: 'RegionRegistrationsConnection';
  edges: Array<Registration>;
  pageInfo: PageInfo;
};

export type RegionStatistic = {
  __typename?: 'RegionStatistic';
  label?: Maybe<Scalars['String']['output']>;
  type?: Maybe<PropertyType>;
  value?: Maybe<Scalars['String']['output']>;
};

export type RegionStrLicensesConnection = {
  __typename?: 'RegionStrLicensesConnection';
  count?: Maybe<Scalars['Int']['output']>;
  edges: Array<StrLicenseEdge>;
  pageInfo?: Maybe<PageInfo>;
};

export type RegionTaxSummary = {
  __typename?: 'RegionTaxSummary';
  numLicensesIncomplete: Scalars['Int']['output'];
  numLicensesPaid: Scalars['Int']['output'];
  numLicensesPaidLate: Scalars['Int']['output'];
  totalEstimatedTaxCents: Scalars['Int']['output'];
  totalPenaltiesAndInterestPaidCents: Scalars['Int']['output'];
  totalTaxPaidCents: Scalars['Int']['output'];
};

export type RegionZonesConfig = {
  __typename?: 'RegionZonesConfig';
  enabled: Scalars['Boolean']['output'];
  strAllowedDefaultValue: Scalars['Boolean']['output'];
  strAllowedLabel?: Maybe<Scalars['String']['output']>;
  strNotAllowedLabel?: Maybe<Scalars['String']['output']>;
  zones?: Maybe<Array<Maybe<Zone>>>;
  zoningFiles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Registration = {
  __typename?: 'Registration';
  date: Scalars['Datetime']['output'];
  license: License;
  updatedBy: Scalars['String']['output'];
};

export type RegistrationPeriod = {
  __typename?: 'RegistrationPeriod';
  endDate?: Maybe<Scalars['Datetime']['output']>;
  registrationType?: Maybe<RegistrationType>;
  startDate?: Maybe<Scalars['Datetime']['output']>;
};

export enum RegistrationType {
  Foreclosed = 'Foreclosed',
  Str = 'STR',
  Vacant = 'Vacant'
}

/**
 * PageInfo type which conforms to Relay specs.
 * See https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo
 */
export type RelayPageInfo = {
  __typename?: 'RelayPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export enum RentalType {
  Current = 'current',
  Ltr = 'ltr',
  Previous = 'previous',
  Unavailable = 'unavailable'
}

export type RentalscapeConfig = {
  __typename?: 'RentalscapeConfig';
  contacts?: Maybe<Array<Maybe<RentalscapeContact>>>;
  emailCcDeckard?: Maybe<Scalars['String']['output']>;
  expressSTRTaxModule?: Maybe<StrTaxModule>;
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  propertyDetails?: Maybe<RentalscapePropertyDetails>;
  propertySummaryMode: RentalscapePropertySummaryMode;
  showOwnerOccupied: Scalars['Boolean']['output'];
  strTaxModule?: Maybe<StrTaxModule>;
};

export type RentalscapeContact = {
  __typename?: 'RentalscapeContact';
  email?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type RentalscapePropertyDetails = {
  __typename?: 'RentalscapePropertyDetails';
  tabs?: Maybe<RentalscapeTabs>;
};

export enum RentalscapePropertySummaryMode {
  Estimated = 'ESTIMATED',
  Identified = 'IDENTIFIED',
  Unknown = 'UNKNOWN'
}

export type RentalscapeTab = {
  __typename?: 'RentalscapeTab';
  enabled: Scalars['Boolean']['output'];
};

export type RentalscapeTabs = {
  __typename?: 'RentalscapeTabs';
  activity: RentalscapeUpgradeableTab;
  history: RentalscapeUpgradeableTab;
  inspections?: Maybe<RentalscapeTab>;
  license: RentalscapeUpgradeableTab;
  tot?: Maybe<RentalscapeTab>;
};

export type RentalscapeUpgradeableTab = {
  __typename?: 'RentalscapeUpgradeableTab';
  enabled: Scalars['Boolean']['output'];
  upgradeRequired: Scalars['Boolean']['output'];
};

export type Report = {
  __typename?: 'Report';
  downloadUrl?: Maybe<Scalars['String']['output']>;
  isAvailable: Scalars['Boolean']['output'];
  reportType: ReportType;
};

export type ReportInspectionResultInput = {
  correctionCompletionDate?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  inspectionResult: InspectionResult;
  inspectionResultBreakDown?: InputMaybe<Scalars['JSON']['input']>;
};

export enum ReportType {
  Registration = 'REGISTRATION'
}

export type ReportedBookings = {
  __typename?: 'ReportedBookings';
  /**
   * The number of nights available for the period.
   * It is null if data is not available.
   */
  nightsAvailable?: Maybe<Scalars['Int']['output']>;
  /**
   * The number of nights booked for the period.
   * It is null if data is not available.
   */
  nightsBooked?: Maybe<Scalars['Int']['output']>;
};

export enum ReportingStatus {
  Reported = 'REPORTED',
  Unreported = 'UNREPORTED'
}

export type StrTaxModule = {
  __typename?: 'STRTaxModule';
  airbnb_remit?: Maybe<AirbnbRemit>;
  collection_agreement?: Maybe<CollectionAgreement>;
  deductions?: Maybe<TaxDeductionsFeature>;
  gross_receipts_description?: Maybe<Scalars['String']['output']>;
  gross_receipts_label?: Maybe<Scalars['String']['output']>;
  tax_config?: Maybe<Array<Maybe<TaxConfigItem>>>;
  taxable_receipts_label?: Maybe<Scalars['String']['output']>;
};

/**
 * Enum `SearchFields` lists searchable fields in the OpenSearch index.
 * Users can specify one or more fields in `searchFields` for targeted multi-field search.
 */
export enum SearchFields {
  /** Parcel Number, a unique identifier for property parcels. */
  Apn = 'APN',
  /** The address associated with the entity’s license. */
  LicenseAddress = 'LICENSE_ADDRESS',
  /** The license identifier for a given entity or property. */
  LicenseNumber = 'LICENSE_NUMBER',
  /** The actual address of the property. */
  PropertyAddress = 'PROPERTY_ADDRESS'
}

export type SingleSignOn = {
  __typename?: 'SingleSignOn';
  attributeMapping: Array<SsoAttributeMapping>;
  emailDomain: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  metadataFile?: Maybe<Scalars['String']['output']>;
  metadataUrl?: Maybe<Scalars['String']['output']>;
};

export type SingleSignOnInput = {
  emailDomain: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  metadataFile?: InputMaybe<Scalars['String']['input']>;
  metadataUrl?: InputMaybe<Scalars['String']['input']>;
};

export type SsoAttributeMapping = {
  __typename?: 'SsoAttributeMapping';
  fromSamlAttribute: Scalars['String']['output'];
  toUserPoolAttribute: SsoUserPoolAttribute;
};

export enum SsoUserPoolAttribute {
  Email = 'EMAIL',
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME'
}

/**
 * Fields returned by RS STR Licenses List is defined in:
 * stroracle-api -> transformations.py -> transform_license_for_license_list() function
 * https://github.com/deckardtech/stroracle-api/blob/main/chalicelib/utils/transformations.py#L340
 *
 * Tables involved in STR Licenses List:
 * - License
 * - Parcel
 * - LicenseApn
 *
 * lastSubmittedRenewal:
 * https://github.com/deckardtech/stroracle-api/blob/main/chalicelib/utils/transformations.py#L244
 */
export type StrLicense = {
  __typename?: 'StrLicense';
  address?: Maybe<Scalars['String']['output']>;
  /**
   * Deckard ID for the property linked to this license. Includes unit, if provided as a part of the license
   * registration process. Unit is used as-is; there's no normalization or additional matching against
   * listing units performed. The source of the unit is the user-provided data in LicenseApn table.
   *
   * If listing/cyborg has unit B8 and license has unit B-8, property deckard IDs won't match. This is the data
   * fix.
   */
  apn: Scalars['String']['output'];
  applicationNumber: Scalars['String']['output'];
  contacts: Array<Contact>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  licenseId: Scalars['ID']['output'];
  licenseNumber?: Maybe<Scalars['String']['output']>;
  licenseStatus?: Maybe<Scalars['String']['output']>;
  numberOfBedrooms: Scalars['Int']['output'];
  occupancy: Scalars['Int']['output'];
  parcel?: Maybe<Parcel>;
  propertyDeckardid?: Maybe<Scalars['String']['output']>;
  taxonomies: Array<TaxonomyTerms>;
  unitNumber?: Maybe<Scalars['String']['output']>;
};


/**
 * Fields returned by RS STR Licenses List is defined in:
 * stroracle-api -> transformations.py -> transform_license_for_license_list() function
 * https://github.com/deckardtech/stroracle-api/blob/main/chalicelib/utils/transformations.py#L340
 *
 * Tables involved in STR Licenses List:
 * - License
 * - Parcel
 * - LicenseApn
 *
 * lastSubmittedRenewal:
 * https://github.com/deckardtech/stroracle-api/blob/main/chalicelib/utils/transformations.py#L244
 */
export type StrLicenseContactsArgs = {
  filter?: InputMaybe<ContactsFilterInput>;
};


/**
 * Fields returned by RS STR Licenses List is defined in:
 * stroracle-api -> transformations.py -> transform_license_for_license_list() function
 * https://github.com/deckardtech/stroracle-api/blob/main/chalicelib/utils/transformations.py#L340
 *
 * Tables involved in STR Licenses List:
 * - License
 * - Parcel
 * - LicenseApn
 *
 * lastSubmittedRenewal:
 * https://github.com/deckardtech/stroracle-api/blob/main/chalicelib/utils/transformations.py#L244
 */
export type StrLicenseTaxonomiesArgs = {
  filter?: InputMaybe<TaxonomiesFilterInput>;
};

export type StrLicenseEdge = {
  __typename?: 'StrLicenseEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: StrLicense;
};

export type StrLicensesFilterInput = {
  /**
   * Show only licenses which are active, whatever customer-specific statuses required for that.
   * False value for this filter is NOT currently supported by the backend. This is technically not a filter, but a place
   * to put subsequent extensions.
   */
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Load multiple licenses at once by IDs. Empty list will guarantee the empty result. */
  licenseIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * List of the field to look for searchTerm in.
   *
   * If `searchFields` is not provided, the search defaults to using only `LICENSE_NUMBER`
   */
  searchFields?: InputMaybe<Array<SearchFields>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  /** License types to include in the result. Missing or empty list means no restrictions. */
  types?: InputMaybe<Array<LicenseType>>;
};

export type SupportContact = {
  __typename?: 'SupportContact';
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  imageUri?: Maybe<Scalars['String']['output']>;
  intro?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SupportInfo = {
  __typename?: 'SupportInfo';
  contacts: Array<SupportContact>;
  resources: Array<SupportResource>;
};

export type SupportResource = {
  __typename?: 'SupportResource';
  description?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  titleLink: Scalars['String']['output'];
};

export type TaxComponent = {
  __typename?: 'TaxComponent';
  taxDue: Scalars['Float']['output'];
  taxName: Scalars['String']['output'];
};

export type TaxConfigItem = {
  __typename?: 'TaxConfigItem';
  breakdown?: Maybe<Array<Maybe<TaxConfigItemDetail>>>;
  infoText?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type TaxConfigItemDetail = {
  __typename?: 'TaxConfigItemDetail';
  infoText?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type TaxDeductionsFeature = {
  __typename?: 'TaxDeductionsFeature';
  enable?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

/** Represents tax details for a specific tax item of a property. All monetary values are in cents. */
export type TaxDetails = {
  __typename?: 'TaxDetails';
  interestInCents?: Maybe<Scalars['Int']['output']>;
  jurisdictionSpecificTaxes: Array<JurisdictionSpecificTaxes>;
  penaltiesInCents?: Maybe<Scalars['Int']['output']>;
  taxableReceiptsInCents?: Maybe<Scalars['Int']['output']>;
  totDueInCents?: Maybe<Scalars['Int']['output']>;
};

/**
 * Represents fields related to tax estimation for a specific tax item of a property.
 * All monetary values are in cents.
 */
export type TaxEstimation = {
  __typename?: 'TaxEstimation';
  /**
   * Estimated number of nights available in the reporting period.
   * It is null if data is not available.
   */
  estimatedNightsAvailable?: Maybe<Scalars['Int']['output']>;
  /**
   * Estimated number of nights booked in the reporting period.
   * It is null if data is not available.
   */
  estimatedNightsBooked?: Maybe<Scalars['Int']['output']>;
  /**
   * Value of estimated tax in the reporting period.
   * It is null if data is not available.
   */
  estimatedTaxInCents?: Maybe<Scalars['Int']['output']>;
  /** Default value is false. */
  hasTaxDiscrepancy: Scalars['Boolean']['output'];
};

export type TaxItem = {
  __typename?: 'TaxItem';
  /**
   * Indicates whether a discrepancy has been investigated.
   * Default is NOT_INVESTIGATED.
   * Using InvestigationStatus as an enum gives flexibility if an investigation lifecycle is introduced later
   * (e.g., PENDING, IN_PROGRESS).
   */
  discrepancyInvestigated?: Maybe<InvestigationStatus>;
  /** Unique id for each tax item record */
  id: Scalars['ID']['output'];
  /** The number of the license which was used to pay taxes. */
  licenseNumber: Scalars['String']['output'];
  numberOfAuthorizedPayees?: Maybe<Scalars['Int']['output']>;
  ownerDetails?: Maybe<Person>;
  payee: Payee;
  property: Property;
  reportedBookings: ReportedBookings;
  taxDetails: TaxDetails;
  /** Includes hasTaxDiscrepancy flag */
  taxEstimation: TaxEstimation;
  taxPayments: TaxPayments;
};

export type TaxItemConnection = {
  __typename?: 'TaxItemConnection';
  edges: Array<TaxItemEdge>;
  pageInfo: PageInfo;
};

export type TaxItemEdge = {
  __typename?: 'TaxItemEdge';
  cursor: Scalars['String']['output'];
  node: TaxItem;
};

export enum TaxItemOrder {
  AddressAsc = 'ADDRESS_ASC',
  AddressDesc = 'ADDRESS_DESC',
  ApnAsc = 'APN_ASC',
  ApnDesc = 'APN_DESC',
  SubmissionDateAsc = 'SUBMISSION_DATE_ASC',
  SubmissionDateDesc = 'SUBMISSION_DATE_DESC'
}

export type TaxItemsFilterInput = {
  /**
   * Optional list of tax item tax discrepancy statuses to filter on. If not present (null or empty list), no additional
   * filtering applied.
   */
  discrepancy?: InputMaybe<Array<DiscrepancyStatus>>;
  interest: Array<InterestStatus>;
  penalties: Array<PenaltyStatus>;
  period: Period;
  removeZeroTaxableReceipts: Scalars['Boolean']['input'];
  reportingStatus: Array<ReportingStatus>;
  searchQuery: Scalars['String']['input'];
  status: Array<PaymentStatus>;
};

export type TaxPayments = {
  __typename?: 'TaxPayments';
  paidInCents: Scalars['Int']['output'];
  paymentSubmissionDate?: Maybe<Scalars['String']['output']>;
  reportedInCents: Scalars['Int']['output'];
  status: PaymentStatus;
  stripePaymentId?: Maybe<Scalars['String']['output']>;
};

export type TaxReport = {
  __typename?: 'TaxReport';
  /** Signed S3 download URL with limited TTL. */
  downloadUrl: Scalars['String']['output'];
  /** ISO timestamp of the link expiration. */
  expires: Scalars['String']['output'];
};

export type TaxSummary = {
  __typename?: 'TaxSummary';
  /**
   * Total tax could be a combination of multiple different taxes,
   * such as TOT and TBID, applied to a particular period. Each
   * of those taxes is represented by a TaxComponent
   */
  taxComponents: Array<TaxComponent>;
};

export type TaxSummaryFilterInput = {
  period: Period;
};

export type TaxonomiesFilterInput = {
  taxonomies: Array<TaxonomyFilterInput>;
};

export enum Taxonomy {
  SupplementalQuestions = 'SUPPLEMENTAL_QUESTIONS',
  Unspecified = 'UNSPECIFIED'
}

export type TaxonomyFilterInput = {
  taxonomy: Taxonomy;
  terms: Array<Scalars['String']['input']>;
};

export type TaxonomySource = {
  __typename?: 'TaxonomySource';
  taxonomy: Taxonomy;
  term: Scalars['String']['output'];
};

export type TaxonomyTerm = {
  __typename?: 'TaxonomyTerm';
  term: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type TaxonomyTerms = {
  __typename?: 'TaxonomyTerms';
  taxonomy?: Maybe<Taxonomy>;
  terms: Array<TaxonomyTerm>;
};

export enum TransactionType {
  ApplicationFee = 'APPLICATION_FEE',
  LateFee = 'LATE_FEE',
  LicenseFee = 'LICENSE_FEE',
  Payment = 'PAYMENT',
  ProcessingFee = 'PROCESSING_FEE',
  RenewalFee = 'RENEWAL_FEE'
}

export type VfprCoordinates = {
  __typename?: 'VFPRCoordinates';
  apn: Scalars['String']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  property: VfprProperty;
};

export type VfprLicense = {
  __typename?: 'VFPRLicense';
  license: License;
  vfprType?: Maybe<VfprType>;
};

export type VfprProperty = {
  __typename?: 'VFPRProperty';
  apn?: Maybe<Scalars['String']['output']>;
  deckardId: Scalars['String']['output'];
  detectedEvents: Array<ParcelForeclosureTransactions>;
  emergencyContact?: Maybe<Person>;
  inspections: Array<Inspection>;
  latestVFPRLicense?: Maybe<License>;
  licenses: Array<VfprLicense>;
  mortgagee?: Maybe<Person>;
  notes: Array<Note>;
  obligationsToRegister: Array<Otr>;
  streetAddress?: Maybe<Scalars['String']['output']>;
  triggerDate?: Maybe<Scalars['Datetime']['output']>;
  type?: Maybe<VfprType>;
};

export type VfprPropertyPage = {
  __typename?: 'VFPRPropertyPage';
  contToken?: Maybe<Scalars['String']['output']>;
  properties: Array<VfprProperty>;
};

export enum VfprType {
  Foreclosed = 'FORECLOSED',
  Vacant = 'VACANT'
}

export type VpfrPropertyCoordsResults = {
  __typename?: 'VPFRPropertyCoordsResults';
  contToken?: Maybe<Scalars['String']['output']>;
  properties: Array<VfprCoordinates>;
};

/**
 * Outreach Letters for Violations.
 *
 * Example of customer-config Violation Outreach Letters configuration:
 * https://github.com/deckardtech/customer-config/blob/131686aaa20ad75613ab4e46ff1e0fd41ffcc427/customer_config/config/ca/placer/county.yml#L319
 *
 * Real Example of Configuration for better understanding of GraphQL Schema Mappings
 * violations:
 *   region_oriented_needs_tot_needs_str_violation: -> violationType
 *     first_outreach_letter: -> OutreachLetter
 *       template: First Warning to Register_ndp - Revised 03212022 (1).docx -> template
 *       type: First Warning to Register -> type
 *     second_outreach_letter:
 *       template: Second Warning to Register-290923.docx
 *       type: Second Warning to Register
 *     third_outreach_letter:
 *       template: Third Warning Deckard Tax Determination 290923.docx
 *       type: Third Warning to Register (FINAL)
 *   exempted_zones_needs_tot_violation:
 *     first_outreach_letter:
 *       template: First Warning to Register_ndp - Revised 03212022 (1).docx
 *       type: First Warning to Register
 *     second_outreach_letter:
 *       template: Second Warning to Register-290923.docx
 *       type: Second Warning to Register
 *     third_outreach_letter:
 *       template: Third Warning Deckard Tax Determination 290923.docx
 *       type: Third Warning to Register (FINAL)
 */
export type ViolationOutreach = {
  __typename?: 'ViolationOutreach';
  /**
   * This represents the specific violation type that we want to send outreach letter for
   * e.g. stay_violation, region_oriented_needs_tot_needs_str_violation
   */
  violationType: Scalars['String']['output'];
};

export type Zone = {
  __typename?: 'Zone';
  name: Scalars['String']['output'];
  strAllowed: Scalars['Boolean']['output'];
};

export type AddInspectionMutationVariables = Exact<{
  regionId: Scalars['String']['input'];
  inspection: InspectionInput;
}>;


export type AddInspectionMutation = { __typename?: 'Mutation', addInspection?: { __typename?: 'Inspection', id?: string | null, apn: string, inspectionTime: any, submissionTime: any } | null };

export type DeleteInspectionMutationVariables = Exact<{
  regionId: Scalars['String']['input'];
  inspectionId: Scalars['String']['input'];
}>;


export type DeleteInspectionMutation = { __typename?: 'Mutation', deleteInspection: boolean };

export type MarkDiscrepancyAsInvestigatedMutationVariables = Exact<{
  regionId: Scalars['ID']['input'];
  taxItemId: Scalars['ID']['input'];
}>;


export type MarkDiscrepancyAsInvestigatedMutation = { __typename?: 'Mutation', markDiscrepancyAsInvestigated: boolean };

export type GetAllTotPermitTransactionsQueryVariables = Exact<{
  regionId: Scalars['String']['input'];
  filters: TaxItemsFilterInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<TaxItemOrder> | TaxItemOrder>;
}>;


export type GetAllTotPermitTransactionsQuery = { __typename?: 'Query', region: { __typename?: 'Region', taxItems: { __typename?: 'TaxItemConnection', edges: Array<{ __typename?: 'TaxItemEdge', node: { __typename?: 'TaxItem', id: string, licenseNumber: string, discrepancyInvestigated?: InvestigationStatus | null, property: { __typename?: 'Property', apn?: string | null, address?: string | null, propertyId: string }, permitHolderDetails: { __typename?: 'Payee', title: string, name: string, phone: string, email: string }, taxPayments: { __typename?: 'TaxPayments', status: PaymentStatus, paymentSubmissionDate?: string | null, paidInCents: number, reportedInCents: number, paymentReferenceNumber?: string | null }, taxEstimation: { __typename?: 'TaxEstimation', estimatedTaxInCents?: number | null, estimatedNightsBooked?: number | null, estimatedNightsAvailable?: number | null, hasTaxDiscrepancy: boolean }, reportedBookings: { __typename?: 'ReportedBookings', nightsAvailable?: number | null, nightsBooked?: number | null }, taxDetails: { __typename?: 'TaxDetails', taxableReceiptsInCents?: number | null, penaltiesInCents?: number | null, interestInCents?: number | null, totDueInCents?: number | null, jurisdictionSpecificTaxes: Array<{ __typename?: 'JurisdictionSpecificTaxes', amountInCents: number, name: string }> }, ownerDetails?: { __typename?: 'Person', name?: string | null, phone?: string | null, email?: string | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage?: string | null, endCursor?: string | null } } } };

export type GetDownloadTotSpreadsheetLinkQueryVariables = Exact<{
  regionId: Scalars['String']['input'];
  filters: TaxItemsFilterInput;
}>;


export type GetDownloadTotSpreadsheetLinkQuery = { __typename?: 'Query', region: { __typename?: 'Region', taxReport: { __typename?: 'TaxReport', downloadUrl: string, expires: string } } };

export type GetInspectionsQueryVariables = Exact<{
  regionId: Scalars['String']['input'];
}>;


export type GetInspectionsQuery = { __typename?: 'Query', getFilteredInspections?: { __typename?: 'FilteredInspections', allInspections?: Array<{ __typename?: 'Inspection', id?: string | null, apn: string, inspectionTime: any, submissionTime: any, notes?: string | null, inspector?: string | null, issueSeverity?: InspectionIssueSeverity | null, propertyType?: string | null, inspectionType?: string | null, inspectionResult?: string | null, propertyAddress?: string | null, misc?: any | null, deckardid?: string | null, attachments?: Array<{ __typename?: 'AttachedFile', id: string, fileName?: string | null, link: string } | null> | null } | null> | null } | null };

export type InspectionListFragment = { __typename?: 'Inspection', id?: string | null, apn: string, inspectionTime: any, submissionTime: any, notes?: string | null, inspector?: string | null, issueSeverity?: InspectionIssueSeverity | null, propertyType?: string | null, inspectionType?: string | null, inspectionResult?: string | null, propertyAddress?: string | null, misc?: any | null, deckardid?: string | null, attachments?: Array<{ __typename?: 'AttachedFile', id: string, fileName?: string | null, link: string } | null> | null };

export type GetInspectionConfigurationQueryVariables = Exact<{
  regionId: Scalars['String']['input'];
}>;


export type GetInspectionConfigurationQuery = { __typename?: 'Query', getCreateInspectionConfig?: { __typename?: 'InspectionConfig', defaultReInspectionPeriod: string, mode?: string | null, read?: Array<string | null> | null, rw?: Array<string | null> | null, propertyTypes: Array<{ __typename?: 'EnumType', type: string, name: string } | null>, inspectionTypes: Array<{ __typename?: 'EnumType', type: string, name: string } | null>, inspectionRole: Array<{ __typename?: 'EnumType', type: string, name: string } | null>, onSiteInspectionSections: Array<{ __typename?: 'InspectionQuestionSection', title: string, type: string, optional: boolean, questions: any, notes?: { __typename?: 'InspectionNote', mode: string, attachments: string, title: string } | null } | null>, inspectionResult?: { __typename?: 'InspectionResultConfig', success: Array<{ __typename?: 'InspectionHeaderBodyHtml', header_html: string, body_html: string } | null>, fail: Array<{ __typename?: 'InspectionHeaderBodyHtml', header_html: string, body_html: string } | null> } | null } | null };

export type InspectionQuestionSectionFragment = { __typename?: 'InspectionQuestionSection', title: string, type: string, optional: boolean, questions: any, notes?: { __typename?: 'InspectionNote', mode: string, attachments: string, title: string } | null };

export type GetOutreachScheduleQueryVariables = Exact<{
  regionId: Scalars['String']['input'];
}>;


export type GetOutreachScheduleQuery = { __typename?: 'Query', getOutreachSchedule?: { __typename?: 'OutreachSchedule', nextRunTime?: string | null, violationOutreachList: Array<{ __typename?: 'ViolationOutreach', violationType: string }> } | null };

export type GetParcelDataAndPropertyContactsByApnQueryVariables = Exact<{
  regionId: Scalars['String']['input'];
  apn: Scalars['String']['input'];
}>;


export type GetParcelDataAndPropertyContactsByApnQuery = { __typename?: 'Query', getParcelDataAndPropertyContactsByApn?: { __typename?: 'ErrorMessage', errorMessage: string } | { __typename?: 'PropertyContacts', parcelData: { __typename?: 'InspectionParcelDataSection', apn: string, state: string, county: string, city: string, propertyAddress: string, ownerName: string, ownerAddress: string, bedrooms: string }, licenseData?: { __typename?: 'LicenseDataForInspection', bedrooms?: string | null } | null, activeLicenseContacts?: Array<{ __typename?: 'LicenseContact', licenseNumber: string, personType: string, name: string, email?: string | null, address?: string | null, phone?: string | null } | null> | null } | null };

export type GetRegionalPaymentStatisticsQueryVariables = Exact<{
  regionId: Scalars['String']['input'];
  filters: TaxSummaryFilterInput;
}>;


export type GetRegionalPaymentStatisticsQuery = { __typename?: 'Query', region: { __typename?: 'Region', taxSummary: { __typename?: 'RegionTaxSummary', totalTaxPaidCents: number, totalPenaltiesAndInterestPaidCents: number, numLicensesPaid: number, numLicensesPaidLate: number, numLicensesIncomplete: number, totalEstimatedTaxCents: number } } };

export type GetSingleInspectionInfoQueryVariables = Exact<{
  regionId: Scalars['String']['input'];
  inspectionId: Scalars['String']['input'];
}>;


export type GetSingleInspectionInfoQuery = { __typename?: 'Query', getSingleInspectionInfo?: { __typename?: 'InspectionSummary', basicInspectionFields: { __typename?: 'Inspection', id?: string | null, apn: string, inspectionTime: any, submissionTime: any, notes?: string | null, inspector?: string | null, issueSeverity?: InspectionIssueSeverity | null, propertyType?: string | null, inspectionType?: string | null, inspectionResult?: string | null, propertyAddress?: string | null, misc?: any | null, attachments?: Array<{ __typename?: 'AttachedFile', id: string, fileName?: string | null, link: string } | null> | null }, ownerDetails?: { __typename?: 'InspectionOwnerDetails', fullName: string, primaryPhone?: string | null, email: string } | null } | null };

export type GetRegionQueryVariables = Exact<{
  regionId: Scalars['String']['input'];
}>;


export type GetRegionQuery = { __typename?: 'Query', region: { __typename?: 'Region', rentalscapeConfig?: { __typename?: 'RentalscapeConfig', name: string, emailCcDeckard?: string | null, showOwnerOccupied: boolean, propertySummaryMode: RentalscapePropertySummaryMode, propertyDetails?: { __typename?: 'RentalscapePropertyDetails', tabs?: { __typename?: 'RentalscapeTabs', license: { __typename?: 'RentalscapeUpgradeableTab', enabled: boolean, upgradeRequired: boolean }, history: { __typename?: 'RentalscapeUpgradeableTab', enabled: boolean, upgradeRequired: boolean }, activity: { __typename?: 'RentalscapeUpgradeableTab', enabled: boolean, upgradeRequired: boolean }, tot?: { __typename?: 'RentalscapeTab', enabled: boolean } | null, inspections?: { __typename?: 'RentalscapeTab', enabled: boolean } | null } | null } | null, expressSTRTaxModule?: { __typename?: 'STRTaxModule', tax_config?: Array<{ __typename?: 'TaxConfigItem', key?: string | null, label?: string | null, infoText?: string | null, breakdown?: Array<{ __typename?: 'TaxConfigItemDetail', key?: string | null, label?: string | null, infoText?: string | null } | null> | null } | null> | null } | null, strTaxModule?: { __typename?: 'STRTaxModule', tax_config?: Array<{ __typename?: 'TaxConfigItem', key?: string | null, label?: string | null, infoText?: string | null, breakdown?: Array<{ __typename?: 'TaxConfigItemDetail', key?: string | null, label?: string | null, infoText?: string | null } | null> | null } | null> | null } | null } | null } };

export type SearchLicensesQueryVariables = Exact<{
  regionId: Scalars['String']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchLicensesQuery = { __typename?: 'Query', region: { __typename?: 'Region', strLicenses: { __typename?: 'RegionStrLicensesConnection', edges: Array<{ __typename?: 'StrLicenseEdge', node: { __typename?: 'StrLicense', licenseNumber?: string | null, address?: string | null, apn: string, propertyDeckardid?: string | null } }> } } };

export const InspectionListFragmentDoc = gql`
    fragment InspectionList on Inspection {
  id
  apn
  inspectionTime
  submissionTime
  notes
  inspector
  issueSeverity
  attachments {
    id
    fileName
    link
  }
  propertyType
  inspectionType
  inspectionResult
  propertyAddress
  misc
  deckardid
}
    `;
export const InspectionQuestionSectionFragmentDoc = gql`
    fragment InspectionQuestionSection on InspectionQuestionSection {
  title
  type
  optional
  notes {
    mode
    attachments
    title
  }
  questions
}
    `;
export const AddInspectionDocument = gql`
    mutation AddInspection($regionId: String!, $inspection: InspectionInput!) {
  addInspection(regionId: $regionId, inspection: $inspection) {
    id
    apn
    inspectionTime
    submissionTime
  }
}
    `;
export type AddInspectionMutationFn = Apollo.MutationFunction<AddInspectionMutation, AddInspectionMutationVariables>;

/**
 * __useAddInspectionMutation__
 *
 * To run a mutation, you first call `useAddInspectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddInspectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addInspectionMutation, { data, loading, error }] = useAddInspectionMutation({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      inspection: // value for 'inspection'
 *   },
 * });
 */
export function useAddInspectionMutation(baseOptions?: Apollo.MutationHookOptions<AddInspectionMutation, AddInspectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddInspectionMutation, AddInspectionMutationVariables>(AddInspectionDocument, options);
      }
export type AddInspectionMutationHookResult = ReturnType<typeof useAddInspectionMutation>;
export type AddInspectionMutationResult = Apollo.MutationResult<AddInspectionMutation>;
export type AddInspectionMutationOptions = Apollo.BaseMutationOptions<AddInspectionMutation, AddInspectionMutationVariables>;
export const DeleteInspectionDocument = gql`
    mutation DeleteInspection($regionId: String!, $inspectionId: String!) {
  deleteInspection(regionId: $regionId, inspectionId: $inspectionId)
}
    `;
export type DeleteInspectionMutationFn = Apollo.MutationFunction<DeleteInspectionMutation, DeleteInspectionMutationVariables>;

/**
 * __useDeleteInspectionMutation__
 *
 * To run a mutation, you first call `useDeleteInspectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInspectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInspectionMutation, { data, loading, error }] = useDeleteInspectionMutation({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      inspectionId: // value for 'inspectionId'
 *   },
 * });
 */
export function useDeleteInspectionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInspectionMutation, DeleteInspectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInspectionMutation, DeleteInspectionMutationVariables>(DeleteInspectionDocument, options);
      }
export type DeleteInspectionMutationHookResult = ReturnType<typeof useDeleteInspectionMutation>;
export type DeleteInspectionMutationResult = Apollo.MutationResult<DeleteInspectionMutation>;
export type DeleteInspectionMutationOptions = Apollo.BaseMutationOptions<DeleteInspectionMutation, DeleteInspectionMutationVariables>;
export const MarkDiscrepancyAsInvestigatedDocument = gql`
    mutation MarkDiscrepancyAsInvestigated($regionId: ID!, $taxItemId: ID!) {
  markDiscrepancyAsInvestigated(regionId: $regionId, taxItemId: $taxItemId)
}
    `;
export type MarkDiscrepancyAsInvestigatedMutationFn = Apollo.MutationFunction<MarkDiscrepancyAsInvestigatedMutation, MarkDiscrepancyAsInvestigatedMutationVariables>;

/**
 * __useMarkDiscrepancyAsInvestigatedMutation__
 *
 * To run a mutation, you first call `useMarkDiscrepancyAsInvestigatedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkDiscrepancyAsInvestigatedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markDiscrepancyAsInvestigatedMutation, { data, loading, error }] = useMarkDiscrepancyAsInvestigatedMutation({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      taxItemId: // value for 'taxItemId'
 *   },
 * });
 */
export function useMarkDiscrepancyAsInvestigatedMutation(baseOptions?: Apollo.MutationHookOptions<MarkDiscrepancyAsInvestigatedMutation, MarkDiscrepancyAsInvestigatedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkDiscrepancyAsInvestigatedMutation, MarkDiscrepancyAsInvestigatedMutationVariables>(MarkDiscrepancyAsInvestigatedDocument, options);
      }
export type MarkDiscrepancyAsInvestigatedMutationHookResult = ReturnType<typeof useMarkDiscrepancyAsInvestigatedMutation>;
export type MarkDiscrepancyAsInvestigatedMutationResult = Apollo.MutationResult<MarkDiscrepancyAsInvestigatedMutation>;
export type MarkDiscrepancyAsInvestigatedMutationOptions = Apollo.BaseMutationOptions<MarkDiscrepancyAsInvestigatedMutation, MarkDiscrepancyAsInvestigatedMutationVariables>;
export const GetAllTotPermitTransactionsDocument = gql`
    query GetAllTOTPermitTransactions($regionId: String!, $filters: TaxItemsFilterInput!, $first: Int, $after: String, $orderBy: [TaxItemOrder!]) {
  region(regionId: $regionId) {
    taxItems(filter: $filters, orderBy: $orderBy, first: $first, after: $after) {
      edges {
        node {
          id
          licenseNumber
          property {
            apn
            address
            propertyId
          }
          permitHolderDetails: payee {
            title
            name
            phone
            email
          }
          taxPayments {
            status
            paymentSubmissionDate
            paidInCents
            reportedInCents
            paymentReferenceNumber: stripePaymentId
          }
          taxEstimation {
            estimatedTaxInCents
            estimatedNightsBooked
            estimatedNightsAvailable
            hasTaxDiscrepancy
          }
          reportedBookings {
            nightsAvailable
            nightsBooked
          }
          taxDetails {
            taxableReceiptsInCents
            penaltiesInCents
            interestInCents
            totDueInCents
            jurisdictionSpecificTaxes {
              amountInCents
              name
            }
          }
          ownerDetails {
            name
            phone
            email
          }
          discrepancyInvestigated
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    `;

/**
 * __useGetAllTotPermitTransactionsQuery__
 *
 * To run a query within a React component, call `useGetAllTotPermitTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTotPermitTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllTotPermitTransactionsQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      filters: // value for 'filters'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetAllTotPermitTransactionsQuery(baseOptions: Apollo.QueryHookOptions<GetAllTotPermitTransactionsQuery, GetAllTotPermitTransactionsQueryVariables> & ({ variables: GetAllTotPermitTransactionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllTotPermitTransactionsQuery, GetAllTotPermitTransactionsQueryVariables>(GetAllTotPermitTransactionsDocument, options);
      }
export function useGetAllTotPermitTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllTotPermitTransactionsQuery, GetAllTotPermitTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllTotPermitTransactionsQuery, GetAllTotPermitTransactionsQueryVariables>(GetAllTotPermitTransactionsDocument, options);
        }
export function useGetAllTotPermitTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllTotPermitTransactionsQuery, GetAllTotPermitTransactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllTotPermitTransactionsQuery, GetAllTotPermitTransactionsQueryVariables>(GetAllTotPermitTransactionsDocument, options);
        }
export type GetAllTotPermitTransactionsQueryHookResult = ReturnType<typeof useGetAllTotPermitTransactionsQuery>;
export type GetAllTotPermitTransactionsLazyQueryHookResult = ReturnType<typeof useGetAllTotPermitTransactionsLazyQuery>;
export type GetAllTotPermitTransactionsSuspenseQueryHookResult = ReturnType<typeof useGetAllTotPermitTransactionsSuspenseQuery>;
export type GetAllTotPermitTransactionsQueryResult = Apollo.QueryResult<GetAllTotPermitTransactionsQuery, GetAllTotPermitTransactionsQueryVariables>;
export const GetDownloadTotSpreadsheetLinkDocument = gql`
    query GetDownloadTotSpreadsheetLink($regionId: String!, $filters: TaxItemsFilterInput!) {
  region(regionId: $regionId) {
    taxReport(filter: $filters) {
      downloadUrl
      expires
    }
  }
}
    `;

/**
 * __useGetDownloadTotSpreadsheetLinkQuery__
 *
 * To run a query within a React component, call `useGetDownloadTotSpreadsheetLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDownloadTotSpreadsheetLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDownloadTotSpreadsheetLinkQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetDownloadTotSpreadsheetLinkQuery(baseOptions: Apollo.QueryHookOptions<GetDownloadTotSpreadsheetLinkQuery, GetDownloadTotSpreadsheetLinkQueryVariables> & ({ variables: GetDownloadTotSpreadsheetLinkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDownloadTotSpreadsheetLinkQuery, GetDownloadTotSpreadsheetLinkQueryVariables>(GetDownloadTotSpreadsheetLinkDocument, options);
      }
export function useGetDownloadTotSpreadsheetLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDownloadTotSpreadsheetLinkQuery, GetDownloadTotSpreadsheetLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDownloadTotSpreadsheetLinkQuery, GetDownloadTotSpreadsheetLinkQueryVariables>(GetDownloadTotSpreadsheetLinkDocument, options);
        }
export function useGetDownloadTotSpreadsheetLinkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDownloadTotSpreadsheetLinkQuery, GetDownloadTotSpreadsheetLinkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDownloadTotSpreadsheetLinkQuery, GetDownloadTotSpreadsheetLinkQueryVariables>(GetDownloadTotSpreadsheetLinkDocument, options);
        }
export type GetDownloadTotSpreadsheetLinkQueryHookResult = ReturnType<typeof useGetDownloadTotSpreadsheetLinkQuery>;
export type GetDownloadTotSpreadsheetLinkLazyQueryHookResult = ReturnType<typeof useGetDownloadTotSpreadsheetLinkLazyQuery>;
export type GetDownloadTotSpreadsheetLinkSuspenseQueryHookResult = ReturnType<typeof useGetDownloadTotSpreadsheetLinkSuspenseQuery>;
export type GetDownloadTotSpreadsheetLinkQueryResult = Apollo.QueryResult<GetDownloadTotSpreadsheetLinkQuery, GetDownloadTotSpreadsheetLinkQueryVariables>;
export const GetInspectionsDocument = gql`
    query GetInspections($regionId: String!) {
  getFilteredInspections(regionId: $regionId) {
    allInspections {
      ...InspectionList
    }
  }
}
    ${InspectionListFragmentDoc}`;

/**
 * __useGetInspectionsQuery__
 *
 * To run a query within a React component, call `useGetInspectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInspectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInspectionsQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *   },
 * });
 */
export function useGetInspectionsQuery(baseOptions: Apollo.QueryHookOptions<GetInspectionsQuery, GetInspectionsQueryVariables> & ({ variables: GetInspectionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInspectionsQuery, GetInspectionsQueryVariables>(GetInspectionsDocument, options);
      }
export function useGetInspectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInspectionsQuery, GetInspectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInspectionsQuery, GetInspectionsQueryVariables>(GetInspectionsDocument, options);
        }
export function useGetInspectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInspectionsQuery, GetInspectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInspectionsQuery, GetInspectionsQueryVariables>(GetInspectionsDocument, options);
        }
export type GetInspectionsQueryHookResult = ReturnType<typeof useGetInspectionsQuery>;
export type GetInspectionsLazyQueryHookResult = ReturnType<typeof useGetInspectionsLazyQuery>;
export type GetInspectionsSuspenseQueryHookResult = ReturnType<typeof useGetInspectionsSuspenseQuery>;
export type GetInspectionsQueryResult = Apollo.QueryResult<GetInspectionsQuery, GetInspectionsQueryVariables>;
export const GetInspectionConfigurationDocument = gql`
    query GetInspectionConfiguration($regionId: String!) {
  getCreateInspectionConfig(regionId: $regionId) {
    defaultReInspectionPeriod
    mode
    read
    rw
    propertyTypes {
      type
      name
    }
    inspectionTypes {
      type
      name
    }
    inspectionRole {
      type
      name
    }
    onSiteInspectionSections {
      ...InspectionQuestionSection
    }
    inspectionResult {
      success {
        header_html
        body_html
      }
      fail {
        header_html
        body_html
      }
    }
  }
}
    ${InspectionQuestionSectionFragmentDoc}`;

/**
 * __useGetInspectionConfigurationQuery__
 *
 * To run a query within a React component, call `useGetInspectionConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInspectionConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInspectionConfigurationQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *   },
 * });
 */
export function useGetInspectionConfigurationQuery(baseOptions: Apollo.QueryHookOptions<GetInspectionConfigurationQuery, GetInspectionConfigurationQueryVariables> & ({ variables: GetInspectionConfigurationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInspectionConfigurationQuery, GetInspectionConfigurationQueryVariables>(GetInspectionConfigurationDocument, options);
      }
export function useGetInspectionConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInspectionConfigurationQuery, GetInspectionConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInspectionConfigurationQuery, GetInspectionConfigurationQueryVariables>(GetInspectionConfigurationDocument, options);
        }
export function useGetInspectionConfigurationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInspectionConfigurationQuery, GetInspectionConfigurationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInspectionConfigurationQuery, GetInspectionConfigurationQueryVariables>(GetInspectionConfigurationDocument, options);
        }
export type GetInspectionConfigurationQueryHookResult = ReturnType<typeof useGetInspectionConfigurationQuery>;
export type GetInspectionConfigurationLazyQueryHookResult = ReturnType<typeof useGetInspectionConfigurationLazyQuery>;
export type GetInspectionConfigurationSuspenseQueryHookResult = ReturnType<typeof useGetInspectionConfigurationSuspenseQuery>;
export type GetInspectionConfigurationQueryResult = Apollo.QueryResult<GetInspectionConfigurationQuery, GetInspectionConfigurationQueryVariables>;
export const GetOutreachScheduleDocument = gql`
    query GetOutreachSchedule($regionId: String!) {
  getOutreachSchedule(regionId: $regionId) {
    nextRunTime
    violationOutreachList {
      violationType
    }
  }
}
    `;

/**
 * __useGetOutreachScheduleQuery__
 *
 * To run a query within a React component, call `useGetOutreachScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOutreachScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOutreachScheduleQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *   },
 * });
 */
export function useGetOutreachScheduleQuery(baseOptions: Apollo.QueryHookOptions<GetOutreachScheduleQuery, GetOutreachScheduleQueryVariables> & ({ variables: GetOutreachScheduleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOutreachScheduleQuery, GetOutreachScheduleQueryVariables>(GetOutreachScheduleDocument, options);
      }
export function useGetOutreachScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOutreachScheduleQuery, GetOutreachScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOutreachScheduleQuery, GetOutreachScheduleQueryVariables>(GetOutreachScheduleDocument, options);
        }
export function useGetOutreachScheduleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOutreachScheduleQuery, GetOutreachScheduleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOutreachScheduleQuery, GetOutreachScheduleQueryVariables>(GetOutreachScheduleDocument, options);
        }
export type GetOutreachScheduleQueryHookResult = ReturnType<typeof useGetOutreachScheduleQuery>;
export type GetOutreachScheduleLazyQueryHookResult = ReturnType<typeof useGetOutreachScheduleLazyQuery>;
export type GetOutreachScheduleSuspenseQueryHookResult = ReturnType<typeof useGetOutreachScheduleSuspenseQuery>;
export type GetOutreachScheduleQueryResult = Apollo.QueryResult<GetOutreachScheduleQuery, GetOutreachScheduleQueryVariables>;
export const GetParcelDataAndPropertyContactsByApnDocument = gql`
    query getParcelDataAndPropertyContactsByApn($regionId: String!, $apn: String!) {
  getParcelDataAndPropertyContactsByApn(regionId: $regionId, apn: $apn) {
    ... on PropertyContacts {
      parcelData {
        apn
        state
        county
        city
        propertyAddress
        ownerName
        ownerAddress
        bedrooms
      }
      licenseData {
        bedrooms
      }
      activeLicenseContacts {
        licenseNumber
        personType
        name
        email
        address
        phone
      }
    }
    ... on ErrorMessage {
      errorMessage
    }
  }
}
    `;

/**
 * __useGetParcelDataAndPropertyContactsByApnQuery__
 *
 * To run a query within a React component, call `useGetParcelDataAndPropertyContactsByApnQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParcelDataAndPropertyContactsByApnQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParcelDataAndPropertyContactsByApnQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      apn: // value for 'apn'
 *   },
 * });
 */
export function useGetParcelDataAndPropertyContactsByApnQuery(baseOptions: Apollo.QueryHookOptions<GetParcelDataAndPropertyContactsByApnQuery, GetParcelDataAndPropertyContactsByApnQueryVariables> & ({ variables: GetParcelDataAndPropertyContactsByApnQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetParcelDataAndPropertyContactsByApnQuery, GetParcelDataAndPropertyContactsByApnQueryVariables>(GetParcelDataAndPropertyContactsByApnDocument, options);
      }
export function useGetParcelDataAndPropertyContactsByApnLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetParcelDataAndPropertyContactsByApnQuery, GetParcelDataAndPropertyContactsByApnQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetParcelDataAndPropertyContactsByApnQuery, GetParcelDataAndPropertyContactsByApnQueryVariables>(GetParcelDataAndPropertyContactsByApnDocument, options);
        }
export function useGetParcelDataAndPropertyContactsByApnSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetParcelDataAndPropertyContactsByApnQuery, GetParcelDataAndPropertyContactsByApnQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetParcelDataAndPropertyContactsByApnQuery, GetParcelDataAndPropertyContactsByApnQueryVariables>(GetParcelDataAndPropertyContactsByApnDocument, options);
        }
export type GetParcelDataAndPropertyContactsByApnQueryHookResult = ReturnType<typeof useGetParcelDataAndPropertyContactsByApnQuery>;
export type GetParcelDataAndPropertyContactsByApnLazyQueryHookResult = ReturnType<typeof useGetParcelDataAndPropertyContactsByApnLazyQuery>;
export type GetParcelDataAndPropertyContactsByApnSuspenseQueryHookResult = ReturnType<typeof useGetParcelDataAndPropertyContactsByApnSuspenseQuery>;
export type GetParcelDataAndPropertyContactsByApnQueryResult = Apollo.QueryResult<GetParcelDataAndPropertyContactsByApnQuery, GetParcelDataAndPropertyContactsByApnQueryVariables>;
export const GetRegionalPaymentStatisticsDocument = gql`
    query GetRegionalPaymentStatistics($regionId: String!, $filters: TaxSummaryFilterInput!) {
  region(regionId: $regionId) {
    taxSummary(filter: $filters) {
      totalTaxPaidCents
      totalPenaltiesAndInterestPaidCents
      numLicensesPaid
      numLicensesPaidLate
      numLicensesIncomplete
      totalEstimatedTaxCents
    }
  }
}
    `;

/**
 * __useGetRegionalPaymentStatisticsQuery__
 *
 * To run a query within a React component, call `useGetRegionalPaymentStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegionalPaymentStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegionalPaymentStatisticsQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetRegionalPaymentStatisticsQuery(baseOptions: Apollo.QueryHookOptions<GetRegionalPaymentStatisticsQuery, GetRegionalPaymentStatisticsQueryVariables> & ({ variables: GetRegionalPaymentStatisticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegionalPaymentStatisticsQuery, GetRegionalPaymentStatisticsQueryVariables>(GetRegionalPaymentStatisticsDocument, options);
      }
export function useGetRegionalPaymentStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegionalPaymentStatisticsQuery, GetRegionalPaymentStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegionalPaymentStatisticsQuery, GetRegionalPaymentStatisticsQueryVariables>(GetRegionalPaymentStatisticsDocument, options);
        }
export function useGetRegionalPaymentStatisticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRegionalPaymentStatisticsQuery, GetRegionalPaymentStatisticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRegionalPaymentStatisticsQuery, GetRegionalPaymentStatisticsQueryVariables>(GetRegionalPaymentStatisticsDocument, options);
        }
export type GetRegionalPaymentStatisticsQueryHookResult = ReturnType<typeof useGetRegionalPaymentStatisticsQuery>;
export type GetRegionalPaymentStatisticsLazyQueryHookResult = ReturnType<typeof useGetRegionalPaymentStatisticsLazyQuery>;
export type GetRegionalPaymentStatisticsSuspenseQueryHookResult = ReturnType<typeof useGetRegionalPaymentStatisticsSuspenseQuery>;
export type GetRegionalPaymentStatisticsQueryResult = Apollo.QueryResult<GetRegionalPaymentStatisticsQuery, GetRegionalPaymentStatisticsQueryVariables>;
export const GetSingleInspectionInfoDocument = gql`
    query GetSingleInspectionInfo($regionId: String!, $inspectionId: String!) {
  getSingleInspectionInfo(regionId: $regionId, inspectionId: $inspectionId) {
    basicInspectionFields {
      id
      apn
      inspectionTime
      submissionTime
      notes
      inspector
      issueSeverity
      attachments {
        id
        fileName
        link
      }
      propertyType
      inspectionType
      inspectionResult
      propertyAddress
      misc
    }
    ownerDetails {
      fullName
      primaryPhone
      email
    }
  }
}
    `;

/**
 * __useGetSingleInspectionInfoQuery__
 *
 * To run a query within a React component, call `useGetSingleInspectionInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleInspectionInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleInspectionInfoQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      inspectionId: // value for 'inspectionId'
 *   },
 * });
 */
export function useGetSingleInspectionInfoQuery(baseOptions: Apollo.QueryHookOptions<GetSingleInspectionInfoQuery, GetSingleInspectionInfoQueryVariables> & ({ variables: GetSingleInspectionInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSingleInspectionInfoQuery, GetSingleInspectionInfoQueryVariables>(GetSingleInspectionInfoDocument, options);
      }
export function useGetSingleInspectionInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSingleInspectionInfoQuery, GetSingleInspectionInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSingleInspectionInfoQuery, GetSingleInspectionInfoQueryVariables>(GetSingleInspectionInfoDocument, options);
        }
export function useGetSingleInspectionInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSingleInspectionInfoQuery, GetSingleInspectionInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSingleInspectionInfoQuery, GetSingleInspectionInfoQueryVariables>(GetSingleInspectionInfoDocument, options);
        }
export type GetSingleInspectionInfoQueryHookResult = ReturnType<typeof useGetSingleInspectionInfoQuery>;
export type GetSingleInspectionInfoLazyQueryHookResult = ReturnType<typeof useGetSingleInspectionInfoLazyQuery>;
export type GetSingleInspectionInfoSuspenseQueryHookResult = ReturnType<typeof useGetSingleInspectionInfoSuspenseQuery>;
export type GetSingleInspectionInfoQueryResult = Apollo.QueryResult<GetSingleInspectionInfoQuery, GetSingleInspectionInfoQueryVariables>;
export const GetRegionDocument = gql`
    query getRegion($regionId: String!) {
  region(regionId: $regionId) {
    rentalscapeConfig {
      name
      emailCcDeckard
      showOwnerOccupied
      propertySummaryMode
      propertyDetails {
        tabs {
          license {
            enabled
            upgradeRequired
          }
          history {
            enabled
            upgradeRequired
          }
          activity {
            enabled
            upgradeRequired
          }
          tot {
            enabled
          }
          inspections {
            enabled
          }
        }
      }
      expressSTRTaxModule {
        tax_config {
          key
          label
          infoText
          breakdown {
            key
            label
            infoText
          }
        }
      }
      strTaxModule {
        tax_config {
          key
          label
          infoText
          breakdown {
            key
            label
            infoText
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetRegionQuery__
 *
 * To run a query within a React component, call `useGetRegionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegionQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *   },
 * });
 */
export function useGetRegionQuery(baseOptions: Apollo.QueryHookOptions<GetRegionQuery, GetRegionQueryVariables> & ({ variables: GetRegionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegionQuery, GetRegionQueryVariables>(GetRegionDocument, options);
      }
export function useGetRegionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegionQuery, GetRegionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegionQuery, GetRegionQueryVariables>(GetRegionDocument, options);
        }
export function useGetRegionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRegionQuery, GetRegionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRegionQuery, GetRegionQueryVariables>(GetRegionDocument, options);
        }
export type GetRegionQueryHookResult = ReturnType<typeof useGetRegionQuery>;
export type GetRegionLazyQueryHookResult = ReturnType<typeof useGetRegionLazyQuery>;
export type GetRegionSuspenseQueryHookResult = ReturnType<typeof useGetRegionSuspenseQuery>;
export type GetRegionQueryResult = Apollo.QueryResult<GetRegionQuery, GetRegionQueryVariables>;
export const SearchLicensesDocument = gql`
    query SearchLicenses($regionId: String!, $searchTerm: String) {
  region(regionId: $regionId) {
    strLicenses(filter: {searchTerm: $searchTerm}, first: 5) {
      edges {
        node {
          licenseNumber
          address
          apn
          propertyDeckardid
        }
      }
    }
  }
}
    `;

/**
 * __useSearchLicensesQuery__
 *
 * To run a query within a React component, call `useSearchLicensesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchLicensesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchLicensesQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useSearchLicensesQuery(baseOptions: Apollo.QueryHookOptions<SearchLicensesQuery, SearchLicensesQueryVariables> & ({ variables: SearchLicensesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchLicensesQuery, SearchLicensesQueryVariables>(SearchLicensesDocument, options);
      }
export function useSearchLicensesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchLicensesQuery, SearchLicensesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchLicensesQuery, SearchLicensesQueryVariables>(SearchLicensesDocument, options);
        }
export function useSearchLicensesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchLicensesQuery, SearchLicensesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchLicensesQuery, SearchLicensesQueryVariables>(SearchLicensesDocument, options);
        }
export type SearchLicensesQueryHookResult = ReturnType<typeof useSearchLicensesQuery>;
export type SearchLicensesLazyQueryHookResult = ReturnType<typeof useSearchLicensesLazyQuery>;
export type SearchLicensesSuspenseQueryHookResult = ReturnType<typeof useSearchLicensesSuspenseQuery>;
export type SearchLicensesQueryResult = Apollo.QueryResult<SearchLicensesQuery, SearchLicensesQueryVariables>;